'use strict';

//========================================================================
// 広域変数
//========================================================================

/**
 * クラス：API呼出し共通実装
 */
export class ApiCommon {

    /**
     * API共通関数：GET
     * @param {string} url 
     * @returns JSON結果
     */
    apiGet(url, data = null)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : url,
                data : (data == null) ? null : data,
                type : "GET",
                async : true,
                cache : false,
                contentType: "application/json",
                dataType : "json",
            }).then(
            function (result) {
                // 正常終了
                resolve(result);
            },
            function (e) {
                if(this.apiErrorProc(e)) {
                    // 共通のエラー処理で対応
                    return
                }
                // エラー
                reject();
            })
        })  
    }

    /**
     * API共通関数：POST
     * @param {string} url 
     * @param {object} data
     * @returns JSON結果
     */
    apiPost(url, data)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : url,
                data : (null == data) ? null : JSON.stringify(data),
                type : "POST",
                async : true,
                cache : false,
                contentType: "application/json",
                dataType : "json",
            }).then(
            function (result) {
                // 正常終了
                resolve(result);
            },
            function (e) {
                if(this.apiErrorProc(e)) {
                    // 共通のエラー処理で対応
                    return
                }
                // エラー
                reject();
            })
        })      
    }

    /**
     * API共通関数：PUT
     * @param {string} url 
     * @param {object} data
     * @returns JSON結果
     */
    apiPut(url, data)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : url,
                data : (null == data) ? null : JSON.stringify(data),
                type : "PUT",
                async : true,
                cache : false,
                contentType: "application/json",
                dataType : "json",
            }).then(
            function (result) {
                // 正常終了
                resolve(result);
            },
            function (e) {
                if(this.apiErrorProc(e)) {
                    // 共通のエラー処理で対応
                    return
                }
                // エラー
                reject();
            })
        })      
    }

    /**
     * API共通関数：DELETE
     * @param {string} url 
     * @returns JSON結果
     */
    apiDelete(url)
    {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : url,
                data : null,
                type : "DELETE",
                async : true,
                cache : false,
                contentType: "application/json",
                dataType : "json",
            }).then(
            function (result) {
                // 正常終了
                resolve(result);
            },
            function (e) {
                if(this.apiErrorProc(e)) {
                    // 共通のエラー処理で対応
                    return
                }
                // エラー
                reject();
            })
        })      
    }

    /**
     * API共通関数：エラー処理
     * @param {object} e 
     * @returns エラー処理有無
     */
    apiErrorProc(e)
    {
        if((423 === e.status) || (503 === e.status)) {
            // 423 Locked 
            // 503 Service Unavailable
            //console.log(e.status + '検出によりリロード')
            // ここでカレント画面をリロードすることで通常遷移側のメンテナンスガードにかかり、メンテナンス画面に遷移させる
            location.reload()
            return true;
        }
        return false;
    }

    /**
     * 汎用のPOST関数
     * @param {string} url 
     * @param {object} data 
     * @returns JSON
     */
    doPost(url, data)
    {
        return this.apiPost(url, data)
    }

    /**
     * 汎用のPUT関数
     * @param {string} url 
     * @param {object} data 
     * @returns JSON
     */
    doPut(url, data)
    {
        return apiPut(url, data)
    }

    /**
     * URLにクエリパラメータを追加
     * params 連想配列
     */
    addUrlParams(url, params)
    {
        let first = true;
        for (let key in params) {
            let param = "";
            if(first) {
                param = "?" + key + "=" + params[key];
                first = false;
            }
            else {
                param = "&" + key + "=" + params[key];
            }
            url += param;
        }
        return url;
    }

    /**
     * フォームへのPOST送信
     * @param {string} url URL
     * @param {array} params パラメタ名称をキーとしたパラメタ値の配列
     */
    formPost(url, params)
    {
        let form = document.createElement("form");
        form.method = "POST";
        form.action = url;
        document.body.append(form);
        // パラメタを hidden につめる
        for (let key in params) {
            let input = document.createElement("input");
            input.type = "hidden";
            input.name = "" + key;
            input.value = "" + params[key];
            form.appendChild(input);
        }
        form.submit();
    }
}
